import { useEffect, useState } from 'react';

const tradingQuotes = [
  "The stock market is a device for transferring money from the impatient to the patient. - Warren Buffett",
  "Risk comes from not knowing what you're doing. - Warren Buffett",
  "The four most dangerous words in investing are: 'This time it's different.' - Sir John Templeton",
  "The goal of a successful trader is to make the best trades. Money is secondary. - Alexander Elder",
  "In trading, just like in life, you have to be patient and wait for the right moment to strike. - Anonymous",
  "The most important quality for an investor is temperament, not intellect. - Warren Buffett",
  "The stock market is filled with individuals who know the price of everything, but the value of nothing. - Philip Fisher",
  "The biggest risk of all is not taking one. - Mellody Hobson",
  "The best investment you can make is in yourself. - Warren Buffett",
  "The stock market is a device for transferring money from the impatient to the patient. - Warren Buffett"
];

const getDailyQuote = () => {
  // Use the day of the year to get a consistent daily quote
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now.getTime() - start.getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  
  return tradingQuotes[dayOfYear % tradingQuotes.length];
};

const Footer = () => {
  const [quote, setQuote] = useState('');

  useEffect(() => {
    setQuote(getDailyQuote());
  }, []);

  return (
    <footer className="bg-white border-t border-gray-200 py-8 mt-12">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Quote Section */}
        <div className="text-center mb-8">
          <p className="text-lg text-gray-600 italic mb-4">"{quote}"</p>
        </div>

        {/* Links Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">Stratible</h3>
            <p className="text-gray-600 text-sm mb-4">
              Your trusted partner in crypto copy trading. Professional trading strategies for all levels.
            </p>
            <div className="text-sm text-gray-600">
              <p>📧 support@stratible.in</p>
              <p>📞 +91-9876543210</p>
              <p>📍 Mumbai, Maharashtra, India</p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <span className="text-gray-600">Trading Levels</span>
              </li>
              <li>
                <span className="text-gray-600">Copy Trading</span>
              </li>
              <li>
                <span className="text-gray-600">Market Analysis</span>
              </li>
              <li>
                <span className="text-gray-600">Trading Signals</span>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <span className="text-gray-600">Contact Us</span>
              </li>
              <li>
                <span className="text-gray-600">Refunds & Cancellations</span>
              </li>
              <li>
                <a 
                  href="mailto:support@stratible.in"
                  className="text-gray-600 hover:text-blue-600 transition-colors"
                >
                  Help Center
                </a>
              </li>
              <li>
                <a 
                  href="mailto:technical@stratible.in"
                  className="text-gray-600 hover:text-blue-600 transition-colors"
                >
                  Technical Support
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 tracking-wide">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <span className="text-gray-600">Terms & Conditions</span>
              </li>
              <li>
                <span className="text-gray-600">Privacy Policy</span>
              </li>
              <li>
                <span className="text-gray-600">Refund Policy</span>
              </li>
              <li>
                <p className="text-gray-500 text-xs">
                  All prices in INR
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-200 pt-6 text-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Stratible. All rights reserved. | 
            <span className="ml-2">All prices displayed in Indian Rupees (INR)</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
